module.exports = __webpack_public_path__ + "img/qacard2.bdf51cfc.png";